// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--+L18k";
export var checkmark = "checkbox-module--checkmark--oPlVj";
export var container = "checkbox-module--container--UORez";
export var input = "checkbox-module--input--v1d0n";
export var label = "checkbox-module--label--q4Pjo";
export var labelContent = "checkbox-module--label-content--6k07b";